// extracted by mini-css-extract-plugin
export default {"button":"cp-z","reviewSort":"dp-z"};